// Extended service metadata for standalone pages.
// Bodies here are the SAME wording already present on the homepage — no rewriting.
// Titles/descriptions/keywords/intent are added ONLY for search engines.

export const SERVICES = [
  {
    slug: 'sales-diagnostic',
    // From existing homepage content
    name: 'Sales Analysis & Implementation',
    body: 'I perform a deep-dive audit of your current operations to build a custom sales department from the ground up, designed for high-impact commercial results.',
    // SEO scaffolding — does not appear in body
    seoTitle: 'Startup Sales Diagnostic & Build | Founder Growth Collective',
    seoDescription: 'Sales diagnostic and function build for funded, founder-led startups. A deep-dive audit and custom sales department designed for high-impact commercial results.',
    intent: ['sales function design', 'sales diagnostic', 'build a sales function'],
  },
  {
    slug: 'sales-framework-design',
    name: 'Revenue Process Design',
    body: 'Engineering a repeatable sales cycle that ensures consistent growth and a seamless journey for every customer.',
    seoTitle: 'Sales Framework Design — Repeatable Sales Process for Startups | Founder Growth Collective',
    seoDescription: 'Engineering a repeatable sales cycle for startups. Consistent growth and a seamless journey for every customer.',
    intent: ['startup sales framework', 'repeatable sales process', 'startup sales process'],
  },
  {
    slug: 'sales-team-hiring',
    name: 'Talent Strategy Plan',
    body: 'Mapping your future headcount and facilitating the interview process to land top-tier talent that drives growth.',
    seoTitle: 'Startup Sales Hiring & Team Structure | Founder Growth Collective',
    seoDescription: 'Startup sales team hiring: mapping future headcount and facilitating the interview process to land top-tier talent that drives growth.',
    intent: ['startup sales hiring', 'sales team structure for startups', 'first sales hire'],
  },
  {
    slug: 'sales-training-ramp',
    name: 'Onboarding Power',
    body: 'Designing comprehensive playbooks that accelerate new hire ramp-up times, ensuring your team hits revenue targets faster.',
    seoTitle: 'Sales Training & Ramp — Onboarding for Startup Sales Hires | Founder Growth Collective',
    seoDescription: 'Sales training and ramp for startups. Comprehensive playbooks that accelerate new hire ramp-up times so your team hits revenue targets faster.',
    intent: ['startup sales training', 'sales onboarding', 'startup sales playbook', 'sales team ramp'],
  },
  {
    slug: 'strategic-sales-advisory',
    name: 'Growth Partnership',
    body: 'Providing high-level counsel for funded founders as they expand, acting as a trusted advisor and senior sales expert for critical decisions.',
    seoTitle: 'Strategic Sales Advisory for Funded Founders | Founder Growth Collective',
    seoDescription: 'Strategic sales advisory for funded founders. High-level counsel from a trusted advisor and senior sales expert for critical growth decisions.',
    intent: ['startup sales advisor', 'sales advisor for founders', 'fractional sales leadership'],
  },
];

export function findService(slug) {
  return SERVICES.find(s => s.slug === slug);
}
